import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./NavBar.css";
import logo from "../HomePage/img/logo.png";
import AuthPopupManager from "../LogIn/AuthPopupManager";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [isTerminalDropdownOpen, setIsTerminalDropdownOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));

    const handleStorageChange = () => {
      const updatedUser = localStorage.getItem("user");
      setUser(updatedUser ? JSON.parse(updatedUser) : null);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const toggleMenu = () => setIsMenuOpen((v) => !v);
  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsTerminalDropdownOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    window.dispatchEvent(new Event("storage"));
    closeMenu();
  };

  // ✅ Check if we are inside terminal pages
  const isTerminalRoute = location.pathname.startsWith("/terminal");

  return (
    <div>
      <nav className="navbar">
        <div className="nav-logo">
          <NavLink to="/" onClick={closeMenu}>
            <img src={logo} alt="logo" />
          </NavLink>
        </div>

        {/* Nav links (desktop + mobile dropdown) */}
        <div className={`nav-links ${isMenuOpen ? "open" : ""}`}>
          {/* Cancel icon (mobile only) */}
          <button className="close-icon" onClick={closeMenu}>
            ✖
          </button>

          {/* Mobile: user.fullName at top */}
          {user && (
            <div className="mobile-auth mobile-auth-top">
              <span className="mobile-username">👋 {user.fullName}</span>
            </div>
          )}

          <NavLink
            to="/"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            About
          </NavLink>
          <NavLink
            to="/all-courses"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            All Courses
          </NavLink>
          <NavLink
            to="/tutorial"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            Tutorials
          </NavLink>
          <NavLink
            to="/contact"
            onClick={closeMenu}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            Contact
          </NavLink>

          {/* ✅ Dropdown for Terminals */}
          <div className={`dropdown ${isTerminalDropdownOpen ? "open" : ""}`}>
            <button
              className={`dropdown-toggle ${
                isTerminalDropdownOpen || isTerminalRoute ? "active" : ""
              }`}
              onClick={() => setIsTerminalDropdownOpen((prev) => !prev)}
            >
              Compiler ▾
            </button>
            <div className="dropdown-menu">
              <NavLink
                to="/terminal/htmlCss"
                onClick={closeMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                HTML & CSS Compiler
              </NavLink>
              <NavLink
                to="/terminal/javascript"
                onClick={closeMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                JavaScript Compiler
              </NavLink>

              <NavLink
                to="/terminal/python"
                onClick={closeMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Python Compiler
              </NavLink>
              <NavLink
                to="/terminal/react"
                onClick={closeMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                React Compiler
              </NavLink>
              <NavLink
                to="/terminal/java"
                onClick={closeMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Java Compiler
              </NavLink>
              <NavLink
                to="/terminal/cpp"
                onClick={closeMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                C++ Compiler
              </NavLink>
              <NavLink
                to="/terminal/c"
                onClick={closeMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                C Programming Compiler
              </NavLink>
            </div>
          </div>

          {/* Mobile: logout OR AuthPopupManager at bottom */}
          <div className="mobile-auth mobile-auth-bottom">
            {user ? (
              <button onClick={handleLogout} className="logout-btn">
                Logout
              </button>
            ) : (
              <AuthPopupManager />
            )}
          </div>
        </div>

        {/* Desktop auth */}
        <div className="nav-auth">
          {user ? (
            <div className="user-info">
              <span>👋 {user.fullName}</span>
              <button onClick={handleLogout} className="logout-btn">
                Logout
              </button>
            </div>
          ) : (
            <AuthPopupManager />
          )}
        </div>

        <button
          className="nav-toggle"
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>
      </nav>

      <div className="navbar-spacer" />
    </div>
  );
};

export default NavBar;
